import React, { useMemo, useRef, useState } from "react";
import { Box, CardMedia, Container, Stack, Typography } from "@mui/material";
// import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import DownloadingIcon from "@mui/icons-material/Downloading";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { IProfileInvestment } from "store/types/user/social";
import { useWindowSizeSelector } from "store";

interface INotableInvestments {
  data: IProfileInvestment[];
}

export const NotableInvestments: React.FC<INotableInvestments> = ({ data }) => {
  if (!data.length) return null;

  const { width: screenWidth } = useWindowSizeSelector();
  const elementRef = useRef<HTMLDivElement | null>(null);
  const [arrowDisable, setArrowDisable] = useState(true);
  const [isShow, setIsShow] = useState(false);

  const handleHorizontalScroll = (element: HTMLDivElement, speed: number, distance: number, step: number) => {
    let scrollAmount = 0;
    const slideTimer = setInterval(() => {
      element.scrollLeft += step;
      scrollAmount += Math.abs(step);
      if (scrollAmount >= distance) {
        clearInterval(slideTimer);
      }
      if (element.scrollLeft === 0) {
        setArrowDisable(true);
      } else {
        setArrowDisable(false);
      }
    }, speed);
  };

  const logo = useMemo(() => {
    return data.map((item) => {
      if (item.company_logo) {
        return (
          <Box
            minWidth="140px"
            minHeight="140px"
            maxHeight="140px"
            maxWidth="140px"
            borderRadius="8px"
            overflow="hidden"
            marginBottom="2px"
            boxShadow="2px 2px 2px rgba(0, 0, 0, 0.10)"
            key={item.id}
          >
            <CardMedia
              key={item.id}
              component="img"
              height="146px"
              width="146px"
              sx={{
                minWidth: "146px",
                maxWidth: "146px",
                backgroundColor: "#ffffff",
                marginTop: "-3px",
                marginLeft: "-3px"
              }}
              src={item.company_logo}
            />
          </Box>
        );
      }
      if (item.company_logo === "") {
        return (
          <Box
            minWidth="140px"
            minHeight="140px"
            maxHeight="140px"
            maxWidth="140px"
            borderRadius="8px"
            overflow="hidden"
            bgcolor="#ffffff"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            gap="6px"
            key={item.id}
          >
            <DownloadingIcon sx={{ color: "#5d7782", width: "33px", height: "33px" }} />
            <Typography lineHeight={1.2} color="#5d7782">
              Fetching logo...
            </Typography>
          </Box>
        );
      }
      if (item.company_logo === null) {
        return (
          <Box
            minWidth="140px"
            minHeight="140px"
            maxHeight="140px"
            maxWidth="140px"
            borderRadius="8px"
            overflow="hidden"
            bgcolor="#ffffff"
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap="8px"
            key={item.id}
          >
            <Typography lineHeight={1.2} color="#0a3142" fontWeight="600">
              {item.company_name}
            </Typography>
          </Box>
        );
      }
    });
  }, [data]);

  const arrowOpacity: number = useMemo(() => {
    if (screenWidth > 1366 && data.length <= 5) return 0;
    if (screenWidth <= 1366 && data.length <= 4) return 0;
    return 1;
  }, [screenWidth, data.length]);

  return (
    <Box sx={{ width: "100%" }}>
      <Typography sx={{ marginBottom: "17px", color: "#0a3142", fontWeight: 500 }}>Notable Investments</Typography>
      <Container
        onMouseEnter={() => setIsShow(true)}
        onMouseLeave={() => setIsShow(false)}
        disableGutters
        sx={{ position: "relative" }}
      >
        {isShow && (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            position="absolute"
            width="100%"
            top="50px"
            padding="0px 10px"
          >
            <Box
              component="div"
              width="40px"
              height="40px"
              bgcolor="#ffffff"
              borderRadius="50%"
              display="flex"
              alignItems="center"
              justifyContent="center"
              sx={{ opacity: arrowDisable ? 0 : 1, cursor: arrowDisable ? "default" : "pointer" }}
              onClick={() => {
                handleHorizontalScroll(elementRef.current as HTMLDivElement, 50, 140, -10);
              }}
            >
              <ArrowLeftIcon
                sx={{
                  height: "35px",
                  width: "35px",
                  fill: "#0a3142"
                }}
              />
            </Box>
            <Box
              component="div"
              width="40px"
              height="40px"
              bgcolor="#ffffff"
              borderRadius="50%"
              display="flex"
              alignItems="center"
              justifyContent="center"
              boxShadow="0 0 4px 0 rgba(0, 0, 0, 0.15)"
              sx={{
                opacity: arrowOpacity,
                cursor: !arrowOpacity ? "default" : "pointer"
              }}
              onClick={() => {
                handleHorizontalScroll(elementRef.current as HTMLDivElement, 50, 140, 10);
              }}
            >
              <ArrowRightIcon sx={{ height: "35px", width: "35px", fill: "#0a3142" }} />
            </Box>
          </Stack>
        )}
        <Stack
          component="div"
          sx={{
            width: "100%",
            maxWidth: "900px",
            display: "flex",
            flexDirection: "row",
            gap: "20px",
            overflow: "hidden"
          }}
          ref={elementRef}
        >
          {logo}
        </Stack>
      </Container>
    </Box>
  );
};
